'use strict';
var React = require('react');
var assetsHelper = require('../helper/assetsHelper');
var ScrollNavigationBar = require('./ScrollNavigationBar');
var IS_LION_SCROLLBAR = /Android|webOS|iPhone|iPad|iPod|OS X|BlackBerry|IEMobile|Opera Mini/i.test(window.navigator.userAgent);

var PageIcons = {
  'psWhite': assetsHelper.getAsset('page_white.png'),
  'psBlue': assetsHelper.getAsset('page_blue.png'),
  'psGreen': assetsHelper.getAsset('page_green.png'),
  'psRed': assetsHelper.getAsset('page_red.png'),
  'psYellow': assetsHelper.getAsset('page_yellow.png'),
  'psGray': assetsHelper.getAsset('page_gray.png')
};

var CurrentPageIcons = {
  'psWhite': assetsHelper.getAsset('page_white2.png'),
  'psBlue': assetsHelper.getAsset('page_blue2.png'),
  'psGreen': assetsHelper.getAsset('page_green2.png'),
  'psRed': assetsHelper.getAsset('page_red2.png'),
  'psYellow': assetsHelper.getAsset('page_yellow2.png'),
  'psGray': assetsHelper.getAsset('page_gray2.png')
};

var FolderIcons = {
  'psWhite': assetsHelper.getAsset('folder_icon.png'),
  'psBlue': assetsHelper.getAsset('folder_blue.png'),
  'psGreen': assetsHelper.getAsset('folder_green.png'),
  'psRed': assetsHelper.getAsset('folder_red.png'),
  'psYellow': assetsHelper.getAsset('folder_yellow.png'),
  'psGray': assetsHelper.getAsset('folder_gray.png')
};

var OpenFolderIcons = {
  'psWhite': assetsHelper.getAsset('folder_icon2.png'),
  'psBlue': assetsHelper.getAsset('folder_blue2.png'),
  'psGreen': assetsHelper.getAsset('folder_green2.png'),
  'psRed': assetsHelper.getAsset('folder_red2.png'),
  'psYellow': assetsHelper.getAsset('folder_yellow2.png'),
  'psGray': assetsHelper.getAsset('folder_gray2.png')
};

var ModuleIcon = {
  'open': assetsHelper.getAsset('folder_icon2.png'),
  'closed': assetsHelper.getAsset('folder_icon.png')
};

var ParentIcon = {
  'open': assetsHelper.getAsset('tree_open.png'),
  'closed': assetsHelper.getAsset('tree_closed.png')
};

/**
 * 获取页面的图标 psWhite, psBlue, psGreen, psRed, psYellow, psGray
 * @param status
 * @param isCurrent 是否是当前选中页面
 * @returns {*|string}
 */
function getIcon(status, isCurrent) {
  if (isCurrent) {
    return PageIcons[status] || PageIcons.psWhite;
  }
  return CurrentPageIcons[status] || CurrentPageIcons.psWhite;
}

/**
 * 获取模块的图标 psWhite, psBlue, psGreen, psRed, psYellow, psGray
 * @param status 状态
 * @param isOpen 是否展开
 * @returns {*|string}
 */
function getFolderIcon(status, isOpen) {
  if (isOpen) {
    return FolderIcons[status] || FolderIcons.psWhite;
  }
  return OpenFolderIcons[status] || OpenFolderIcons.psWhite;
}

/**
 * 判断某根节点是否在当前页面的路径上
 * @param node 要判断的根节点
 * @param targetId 目标节点的id
 * @returns {*|bool}
 */
function isCurrentPath(node, current) {
  if(node._pages) {
    var children = node._pages;
    for(var i=0;i<children.length;i++) {
      if(children[i].ID === current) {
        return true;
      }
      if(isCurrentPath(children[i], current)) {
        return true;
      }
    }
  }
  return false;
}


/**
 * 页面
 */
var Page = React.createClass({
  propTypes: {
    node: React.PropTypes.object.isRequired,
    show: React.PropTypes.bool.isRequired,
    current: React.PropTypes.string.isRequired
  },
  render: function () {
    var node = this.props.node;
    var current = this.props.current;
    var className = '';
    var style = {};
    var isCurrent = node.ID === current;
    if (isCurrent) {
      className = 'current';
    }
    if (!this.props.show) {
      style.display = 'none';
    }
    return (
      <li className={className}
          key={node.ID}
          style={style}
          onClick={this.onSelectPage}>
        <span className='node-name'><img width="10" height="14"
                                         src={getIcon(node.status, isCurrent)}/>{node.name}</span>
        {
          node._pages && node._pages.length &&
          <ul>
            {node._pages.map(function (subNode) {
              return (
                <Page node={subNode}
                      current={current}
                      onSelectPage={this.props.onSelectPage}/>
              );
            }, this)}
          </ul>
        }
      </li>
    );
  },
  onSelectPage: function (e) {
    this.props.onSelectPage(this.props.node.ID);
    e.stopPropagation();
  }
});

/**
 * 模块
 */
var Module = React.createClass({
  propTypes: {
    root: React.PropTypes.bool,
    node: React.PropTypes.object.isRequired,
    show: React.PropTypes.bool.isRequired,
    current: React.PropTypes.string.isRequired
  },
  getInitialState: function () {
    var flag = isCurrentPath(this.props.node, this.props.current);
    return {
      expand: flag
    };
  },
  componentWillReceiveProps: function(nextProps) {
    var flag = isCurrentPath(nextProps.node, nextProps.current);
    //节点处于收起状态时，根据是否当前路径决定节点的expand标志
    if(!this.state.expand) {
      this.setState({expand: flag});
    }
  },

  render: function () {
    var showItem = this.state.expand || false;
    var style = {};
    var statusPath;
    var currentClassName = 'module';
    var statusClassName = 'status';
    var pages;

    if (this.props.root) {
      currentClassName += ' root';
    }

    if (!this.props.show) {
      style.display = 'none';
    }

    if (this.state.expand) {
      statusPath = ParentIcon.open;
    } else {
      statusPath = ParentIcon.closed;
      statusClassName += ' closed';
    }

    pages = this.props.node._pages;

    if (!pages) {
      currentClassName += ' module-without-children';
    }

    return (
      <li className={currentClassName} style={style}>
        {pages &&
        <i className={statusClassName} onClick={this.onToggleExpand}>
          <img src={statusPath}/>
        </i>
        }
        {this.renderNameWithIcon()}
        <ul>
          {
            pages && pages.map(function (node) {
              if (node.isModule || node._pages) {
                return (
                  <Module node={node}
                          key={node.ID}
                          show={showItem}
                          current={this.props.current}
                          onSelectPage={this.props.onSelectPage}/>
                );
              }
              return (
                <Page key={node.ID}
                      show={showItem}
                      node={node}
                      current={this.props.current}
                      onSelectPage={this.props.onSelectPage}/>
              );
            }, this)
          }
        </ul>
      </li>
    );
  },
  renderNameWithIcon: function () {
    var iconPath;
    var nodeNameClassName = 'node-name';
    var iconSize;
    var nodeName = this.props.node.name;
    var status = this.props.node.status;
    var pages = this.props.node.pages;
    if (this.props.node.isModule && this.props.node.childCount > 0) {
      nodeName += ' (' + this.props.node.childCount + ')';
    }

    if (this.props.node.isModule) { // 是模块
      if (status === undefined) {
        iconPath = ModuleIcon[this.state.expand ? 'open' : 'closed'];
      } else {
        iconPath = getFolderIcon(status, this.state.expand);
      }
      iconSize = {
        width: 16,
        height: 16
      };
    } else {
      iconPath = getIcon(this.props.node.status, this.props.node.ID === this.props.current);
      iconSize = {
        width: 10,
        height: 14
      };
    }

    if (this.props.node.ID === this.props.current) {
      nodeNameClassName += ' current';
    }
    return (
      <span className={nodeNameClassName}
            onClick={this.onClick}
            onDoubleClick={this.onToggleExpand}>
        <img width={iconSize.width} height={iconSize.height} src={iconPath}/>
        {nodeName}
      </span>
    );
  },
  /**
   * 切换子项是否展开
   */
  onClick: function (e) {
    if (this.props.node.isModule) {
      this.onToggleExpand(e);
    } else {
      this.props.onSelectPage(this.props.node.ID);
    }
    e.stopPropagation();
  },
  onToggleExpand: function (e) {
    this.setState({
      expand: !this.state.expand
    });
    e.stopPropagation();
  }
});

/**
 * 项目树
 */
var Tree = React.createClass({
  propTypes: {
    name: React.PropTypes.string.isRequired,
    modules: React.PropTypes.object.isRequired,
    current: React.PropTypes.object.isRequired,
    onSelectPage: React.PropTypes.func.isRequired,
    scrollBarShow: React.PropTypes.bool
  },
  getInitialState: function () {
    return {
      scrollBarShow: true,
      Scroll: "scroll",
      scrollBar: "scrollBar",
      moveMain: "tree"
    };
  },
  render: function () {
    var style = {
      width: '240px',
      height: '100%',
      overflow: 'auto',
      paddingRight: 20,
      position: 'relative',
      overflowX: 'inherit'
    };
    if (IS_LION_SCROLLBAR) {
      return (
        <div onClick={this.scrollEvent} style={style}>
          <div className="tree" ref="treeNode">
            <ul>
              <Module
                root={true}
                node={{
                  isModule: true,
                  name: this.props.name,
                  _pages: this.props.modules._pages,
                  childCount: this.props.modules.childCount
                }}
                show={true}
                current={this.props.current.ID}
                onSelectPage={this.props.onSelectPage}/>
            </ul>
          </div>
        </div>
      );
    }
    return (
      <div onClick={this.scrollEvent} style={style}>
        <ScrollNavigationBar>
          <div className="tree" ref="treeNode">
            <ul>
              <Module
                root={true}
                node={{
                  isModule: true,
                  name: this.props.name,
                  _pages: this.props.modules._pages,
                  childCount: this.props.modules.childCount
                }}
                show={true}
                current={this.props.current.ID}
                onSelectPage={this.props.onSelectPage}/>
            </ul>
          </div>
        </ScrollNavigationBar>
      </div>
    );
  },
  scrollEvent: function () {
    document.addEventListener('onMouseOver', this.onScrollPlay);
  },
  onScrollPlay: function (e) {
    consoel.log(e)
  }
});

module.exports = Tree;


// WEBPACK FOOTER //
// ./src/views/Tree.jsx